import { render, staticRenderFns } from "./CoffeItensReport.vue?vue&type=template&id=47904a1a&scoped=true&"
import script from "./CoffeItensReport.vue?vue&type=script&lang=js&"
export * from "./CoffeItensReport.vue?vue&type=script&lang=js&"
import style0 from "./CoffeItensReport.vue?vue&type=style&index=0&id=47904a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47904a1a",
  null
  
)

export default component.exports